import React from "react";
import classes from "./CheckDetails.module.css";
import FireboardUtil from "../../../../../util/fireboard-util";
import constants from "../../../../../globalization";
import MenuUtils from "../../../../../util/menu-utils";
import classNames from "classnames";
import paidIcon from "../../../../../assets/images/Fireboard/paid.png";

const CheckItem = (props) => {
  const {
    item = {},
    currency = '$',
  } = props;

  const renderModifiers = (mod, index) => {
    if (mod) {
      const modText =
        mod.quantity > 1
          ? `- ${mod.quantity} x ${mod.modifierName}`
          : `- ${mod.modifierName}`;
      const modString = `${modText} ${mod.price > 0 ? `(${currency} ${mod.price.toFixed(2)})` : ""
        }`;
      const note = mod.quantity > 1 ? `\t\t\t\t\t\t  ${mod.comment}` : `  \t\t\t  ${mod.comment}`;
      return (
        <>
        <span
          className={classes.checkCellView}
          style={{ paddingLeft: `${index * 1.5}vw`, width: "100%" }}
        >
          {modString}
        </span>
        {mod.comment ? (
          <span
            className={classNames(
              `${classes.checkCellView}`,
              `${classes.modNote}`
            )}
          >
            {note}
          </span>
        ) : null}
        </>
      );
    }
    return <span />;
  };

  const renderModifiersRecursively = (im) =>
    MenuUtils.renderModifiersRecursively(
      im,
      0,
      (i, index) => renderModifiers(i, index),
      (i) => { },
      true
    );

  const comment =
    item.quantity > 1 ? `\t\t\t  ${item.comment}` : `  ${item.comment}`;

  return (
    <div className={item.pending ? classNames(
      `${classes.itemContainer}`,
      `${classes.pendingBg}`,
    ) : classes.itemContainer}>
      <div className={classes.rowSpaceBetween}>
        <div className={classes.nameAndPrice}>
          <span
            className={classNames(`${classes.checkCellView}`, `${classes.name}`)}
          >
            {`${item.quantity > 1 ? `${item.quantity} x ` : ""}${item.menuItemName
              }`}
          </span>
          {item.comment ? (
            <span
              className={classNames(
                `${classes.checkCellView}`,
                `${classes.note}`
              )}
            >
              {comment}
            </span>
          ) : null}
        </div>
        {item.modifiers ? renderModifiersRecursively(item) : null}
      </div>
      <div className={classes.paidBtnWrapper}>
        {item?.paid ? <img src={paidIcon} alt="paid" className={classes.paidImg} /> : null}
      </div>
      <span
        className={classNames(
          `${classes.checkCellView}`,
          `${classes.price}`
        )}
      >
        {`${currency}${item && item.price && item.price.toFixed(2)}`}
      </span>
    </div>
  );
};

const CheckItems = (props) => {
  const {
    items = [],
    selectedItem = {},
    posItemKeys = [],
    currency = '$',
  } = props || {};

  const isPOSOrder =
  FireboardUtil.getOrderTypeFromSourceType(selectedItem.sourceType) ===
    constants.orderType_POS;

  const renderPOSCheck = (item) => {
    return (
      <div className={classes.checkItem}>
        {item ? (
          <button className={classes.itemSelected}>
            <span
              className={classes.selectedItemText}
              style={{
                color: item === constants.discountHeader ? "#AD0028" : "black",
              }}
            >
              {item}
            </span>
          </button>
        ) : null}
        {items[item] && items[item].map((itemObj) => renderCheckItems(itemObj))}
      </div>
    );
  };

  const renderCheckItems = item => {
    return (
      <CheckItem
        key={`checkItem-${item.id}`}
        item={item}
        selectedItem={selectedItem}
        currency={currency}
      />
    );
  };

  const checkItemsArray = isPOSOrder ? posItemKeys : items;
  return (
    <div className={classNames(`${classes.checkItemsContainer}`)}>
      {Array.isArray(checkItemsArray) && checkItemsArray.length
        ? checkItemsArray.map((item, itemIndex) => {
          if (isPOSOrder) {
            return <div key={`posItem-${itemIndex}`}>{renderPOSCheck(item)}</div>;
          }
          return <div key={`menuItem-${itemIndex}`}>{renderCheckItems(item)}</div>;
        })
        : null}
    </div>
  );
};

export default CheckItems;
